// extracted by mini-css-extract-plugin
export default {"marquee":"vRu5FBuj"};